module.exports = __webpack_public_path__ + "static/2-9ee71eaa19a2db480ecea8b53bd8e65b.jpg";